import { Fragment, useCallback, useEffect, useState } from 'react'
import AppLayout from '../../../../baseComponents/AppLayout'
import { twinCountries } from '../../../../utils/globals/countries'
import { connectToSocket } from '../../../../utils/globals/socket'
import ErpLoaderEmployeeModal from './ErpLoaderEmployeeModal'
import { checkIfEmployeeIsValid, getAndChangeCompany, getAndChangeConfig, getAndChangeNotifications, getMyWorkingTask } from './functions'
import { ErpLoaderLoaded } from './types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import LoadingSpinner from '../../../../baseComponents/LoaderDecider/LoadingSpinner'
import ErpLoaderCompanyModal from './ErpLoaderCompanyModal'
import { setUserIfCookieValid, signOutUser } from '../../../../utils/reducers/reduxDispatch'
import { AllReduxAppPayloads, GlobalContext } from '../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'

interface ErpLoaderProps extends ErpLoaderLogicProps {
    children?: React.ReactNode
}

const ErpLoader: React.FC<ErpLoaderProps> = ({ children, ...logic }) => {
    const { loaded, setLoaded, onChooseCompany, loadCompany } = useErpLoaderLogic({...logic})
    if (!loaded) {
        return <ERPLoadingScreen />
    }
    return (
        <Fragment>
            {loaded === 'companyLeft' && <ErpLoaderCompanyModal loaded={loaded} setLoaded={onChooseCompany} />}
            {loaded === 'employeeLeft' && <ErpLoaderEmployeeModal loaded={loaded} setLoaded={setLoaded} loadCompany={loadCompany} />}
            {loaded === true ? children : <AppLayout routes={[]} appStyle='new1' bookMarkParsed={[]} bookMarkParsedDict={undefined}></AppLayout>}
        </Fragment>
    )
}
interface ErpLoaderLogicProps extends ReduxErpLoaderConnector {}

const useErpLoaderLogic = ({ changeMultiUser }: ErpLoaderLogicProps) => {
    const [loaded, setLoaded] = useState<ErpLoaderLoaded>(false)
    const {t} = useTwinTranslation()
    const reconnectedMsg = t('reconnectedSuccessfully', 'Reconectado correctamente')
    const loadCompany = useCallback(async () => {
        await Promise.all([
            getAndChangeCompany(),
            getAndChangeConfig(),
            twinCountries(),
            getMyWorkingTask(),
        ])
        connectToSocket(reconnectedMsg)
        getAndChangeNotifications()
    }, [reconnectedMsg])
    const getStartedValues = useCallback(async () => {
        const isValid = await checkIfEmployeeIsValid()
        if (isValid?.status === 202) {
            setLoaded('companyLeft')
        } else if (isValid?.status === 200) {
            if (isValid.text === 'true') {
                await loadCompany()
                setLoaded(true)
            } else {
                setLoaded('employeeLeft')
            }
        } else if (isValid?.status === 422) {
            await signOutUser()
        } else if (isValid?.status === 423) {
            setLoaded(true)
        }
    }, [loadCompany])

    const onChooseCompany = useCallback(() => {
        getStartedValues()
    }, [getStartedValues])

    const resetEmployeeByToken = useCallback(async () => {
        await setUserIfCookieValid()
        await getStartedValues()
    }, [getStartedValues])

    useEffect(() => {
        getStartedValues()
    }, [getStartedValues])

    useEffect(() => {
        if (changeMultiUser && loaded === true){
            resetEmployeeByToken()
        }
    }, [changeMultiUser, loaded, resetEmployeeByToken])

    return { loaded, setLoaded, onChooseCompany, loadCompany }
}

const ERPLoadingScreen: React.FC = () => {
    const { t } = useTwinTranslation()
    return (
        <div className='erp_screen_loader'>
            <h1>{t('loadingERP', 'Cargando ERP...')}</h1>
            <LoadingSpinner />
        </div>
    )
}

const erpLoaderDispatch = {
}
const mapErpLoaderConnector = (state: AllReduxAppPayloads) => ({ changeMultiUser: state.user?.changeMultiUser })
const erpLoaderConnector = connect(mapErpLoaderConnector, erpLoaderDispatch, null, { context: GlobalContext })
type ReduxErpLoaderConnector = ConnectedProps<typeof erpLoaderConnector>
export const ErpLoaderConnect = erpLoaderConnector(ErpLoader)

export default ErpLoaderConnect